import React, { useMemo, useRef } from "react";

import { isEmptyArray, isNonEmptyArray, isNonEmptyObject } from "_helpers";

import { Badge, Col, Row, Typography } from "antd";

import { ReactComponent as Dailydump } from "_assets/dashboard/dailydump.svg";
import { ReactComponent as Mail } from "_assets/dashboard/mail.svg";
import { ReactComponent as Email } from "_assets/dashboard/email.svg";
import { ReactComponent as Sms } from "_assets/dashboard/sms.svg";

export const CollapseHeaderCustom = ({ entries }) => {
    const { Title } = Typography;
    const { key, val } = entries;

    let baseVar = 'Base', otherVar = 'Autre';
    if( val.length > 1 ){
        baseVar+= 's';
        otherVar+= 's';
    } 

    const defaults = useRef({ height: 30, width: 30, cursor: 'default' }).current;

    const badgesColor = useMemo(() => {
        if( isEmptyArray(val) ) return {
            dailyDumpColor: null,
            mailColor: null,
            emailColor: null,
            smsColor: null
        };

        let colors = {};
        val.forEach(v => {
            ['apilog', 'envelope'].forEach(k => {
                if( v?.[k] && isNonEmptyObject(v[k]) ){
                    if( !colors.hasOwnProperty(k) ) colors[k] = 'green';
                    if( colors[k] === 'green' && v[k]?.status === 'KO' ) colors[k] = 'red';
                }
            });
            ['email', 'sms'].forEach(k => {
                if( (v?.[k]?.inbox && isNonEmptyObject(v[k].inbox)) || (v?.[k]?.outbox && isNonEmptyObject(v[k].outbox)) ){
                    if( !colors.hasOwnProperty(k) ) colors[k] = 'green';
                    if( colors[k] === 'green' && (v?.[k]?.inbox?.status === 'KO' || v?.[k]?.outbox?.status === 'KO') ) colors[k] = 'red';
                }
            });
        })

        return {
            dailyDumpColor: colors?.apilog || null,
            mailColor: colors?.envelope || null,
            emailColor: colors?.email || null,
            smsColor: colors?.sms || null
        }
    }, [val]);

    return (
        <div className="ant-collapse-header" >
            <Row>
                <Col xs={22}>
                    <Title level={2}>
                        {
                            ['veo', 'veowhite'].includes(key)
                            ?
                                <div>{baseVar} {key}</div>
                            :
                                <div>{otherVar} {baseVar.toLowerCase()}</div>
                        }
                    </Title>
                </Col>
                <Col xs={2}>
                    <div className="d-flex justify-content-end">
                        {
                            badgesColor.dailyDumpColor &&
                            <Badge dot color={badgesColor.dailyDumpColor} offset={[-4,0]}>
                                <Dailydump className="mx-1" {...defaults} />
                            </Badge>
                        }
                        {
                            badgesColor.mailColor &&
                            <Badge dot color={badgesColor.mailColor} offset={[-4,0]}>
                                <Mail className="mx-1" {...defaults} />
                            </Badge>
                        }
                        {
                            badgesColor.emailColor &&
                            <Badge dot color={badgesColor.emailColor} offset={[-4,0]}>
                                <Email className="mx-1" {...defaults} />
                            </Badge>    
                        }
                        {
                            badgesColor.smsColor &&
                            <Badge dot color={badgesColor.smsColor} offset={[-4,0]}>
                                <Sms className="mx-1" {...defaults} />
                            </Badge>
                        }
                    </div>
                </Col>
            </Row>
            
        </div>
    );
}